module.exports = __webpack_public_path__ + "media/fonts/alternate-gothic-no3-regular-webfont-05972b38fe7a1a169ece4d78934b5986.svg";